import LoginPage from './page/sign-in/login.page';
import MainPage from './page/main/main-page';
import MyAccountPage from './page/my-account/my-account.page';
import GroupManagement from './page/group/group-management.page';
import {
    Person2Outlined, CorporateFareOutlined, FolderDeleteOutlined, DvrOutlined, SwapHoriz,
    CloudOutlined, HealthAndSafetyOutlined, DisplaySettings,
    Settings, GridOn, MonetizationOnOutlined, AccountBoxOutlined, DocumentScannerOutlined
} from '@mui/icons-material';
import AnagraficaOcrSessionsPage from './page/anagrafica-ocr-sessions/anagrafica-ocr-sessions.page';

import SensitiveRecord from './page/sensitive-operation-record/sensitive-operations.page';
import DeletedResource from './page/deleted-resource/deleted-resource.page';
import DataAnalysisManagement from './page/data-analysis/data-analysis.page';
import HistoryDataPage from './page/data-analysis/history-data/history-data.page';
import HistoryOrderDataPage from './page/data-analysis/history-order-data/history-order-data.page';
import DishDataPage from './page/data-analysis/dish-data/dish-data.page';
import DailyBusinessSummaryPage from './page/data-analysis/daily-business-summary/daily-business-summary-page';
import StaffDataPage from './page/data-analysis/staff-data/staff-data.page';
import RefundDishDataPage from './page/data-analysis/refund-data/refund-data.page';
import SensitiveDataPage from './page/data-analysis/sensitive-data/sensitive-data.page';
import TunnelManagementPage from './page/tunnel-management/tunnel-management';
import DishMenuShellPage from './page/dish-menu-creator/dish-menu-shell.page';
import MyRestaurantPage from './page/my-restaurant/my-restaurant.page';
import RbpCloudSubFunctionPage from './page/rbp-cloud-sub-function/rbp-cloud-sub-function.page';
import EmployeeManagementPage from './page/employee-management/employee-management.page';
import DeliverectPage from './page/deliverect-log/deliverect-setting.page';
import VivaWalletSettingPage from './page/viva-wallet/viva-wallet-setting.page';
import LoginOperationList from './page/login-operations/login-operation-list';
import SharkLoginOperationList from './page/shark-login-operations/shark-login-operation-list';
import SharkVersionList from './page/shark-version-statistics/shark-version-list';
import SharkBackupOperationList from './page/shark-backup-operations/shark-backup-operation-list';
import DataBubblePage from './page/data-bubble/data-bubble.page';
import ResellerManagement from './page/reseller/reseller-management.page';
import ResellerConsumptionPage from './page/reseller-consumption/reseller-consumption.page';
import ProductListPage from './page/product-list/product-list.page';
import QOPTunnelManagementPage from './page/qop-tunnel-management/qop-tunnel-management';
import FiskalySettingAdmin from './page/fiskaly-setting-admin/fiskaly-setting-page';
import PixabaySettingAdmin from './page/pixabay-setting-admin/pixabay-setting-page';
import FiskalySettingStaff from './page/fiskaly-settiing-staff/fiskaly-settinig-page';
import IntelligentRiskControlPage from './page/restaurant-risk/intelligent-risk-control.page';
import FiskalySettingUser from './page/fiskaly-settiing-user/fiskaly-settiing-page';
import GroupRevenueAnalysisPage from './page/group-revenue-analysis/group-revenue-analysis.page';
import MenuLibraryManagementPage from './page/menu-library-management/menu-library-management.page';
import MenuStorePage from './page/menu-store/menu-store.page';
import SharkSetting from './page/shark-setting/shark-setting';
import { WarrantCode } from './models';

// 导入图标
// 营业分析
import { ReactComponent as AnalysisIcon } from './static/images/svg/fluent_data-usage-16-filled.svg';
// 集团营收分析
import { ReactComponent as GroupRevenueIcon } from './static/images/svg/bxs_store.svg';
// 餐厅风控
import { ReactComponent as IntelligentRiskControlIcon } from './static/images/svg/si_shield-tip-fill.svg';
// 菜单库管理
import { ReactComponent as MenuLibraryIcon } from './static/images/svg/auto_stories.svg';
// 菜单商店
import { ReactComponent as MenuStoreIcon } from './static/images/svg/material-symbols_menu-book-2-rounded.svg';
// 当前营业状态
import { ReactComponent as CurrentBusinessStatusIcon } from './static/images/svg/clarity_dashboard-solid.svg';
import RestaurantSettingsPage from './page/my-restaurant/restaurant-settings.page';
import ParkModePage from './page/park-mode/park-mode.page';
import PrintModulePage from './page/print/print-module.page';


/**
 * 需要登入访问的路由
 */
export const genRoutes: () => RoutesType[] = () => ([
    {
        path: '/main',
        name: 'main',
        component: MainPage,
        id: '2',
        pid: '0',
        isTab: true,
        private: true,
        children: [
            {
                // 我的账号
                icon: () => <Person2Outlined />,
                path: '/main/account',
                name: 'main_page_text_person_page',
                component: MyAccountPage,
                id: '2_1',
                pid: '2',
                isHideNav: true
            }, {
                // 集团管理
                icon: () => <CorporateFareOutlined />,
                path: '/main/group',
                name: 'main_page_text_group_management',
                component: GroupManagement,
                id: '2_2',
                pid: '2',
                only: ['ADMIN', 'RESELLER']
            }, {
                // 隧道管理
                icon: () => <SwapHoriz />,
                path: '/main/tunnel-management',
                name: 'tunnel_management_page_text_restaurant_tunnel_management',
                component: TunnelManagementPage,
                id: '2_7',
                pid: '2',
                only: ['ADMIN', 'RESELLER']
            }, {
                // 隧道管理
                icon: () => <SwapHoriz />,
                path: '/main/qop-tunnel-management',
                name: 'qop_tunnel_management_page_text_restaurant_tunnel_management',
                component: QOPTunnelManagementPage,
                id: '2_9',
                pid: '2',
                only: ['ADMIN', 'RESELLER']
            }, {
                // 资源回收站
                icon: () => <FolderDeleteOutlined />,
                path: '/main/recycle_bin',
                name: 'main_page_text_recycle_bin',
                component: DeletedResource,
                id: '2_3',
                pid: '2',
                only: ['ADMIN', 'RESELLER']
            }, {
                // 敏感操作记录
                icon: () => <DvrOutlined />,
                path: '/main/business',
                name: 'business_analysis_page_sensitive_operation_record',
                component: SensitiveRecord,
                id: '2_4',
                pid: '2',
                only: ['ADMIN', 'RESELLER']
            }, {
                // 登录日志
                icon: () => <HealthAndSafetyOutlined />,
                path: '/main/login-operation',
                name: 'login_operation_page_text_login_operation',
                component: LoginOperationList,
                id: '2_10',
                pid: '2',
                only: ['ADMIN', 'RESELLER']
            }, {
                // 设置
                icon: () => <Settings />,
                path: '/main/setting',
                name: 'setting_page_title_setting',
                component: '',
                id: '2_setting',
                pid: '2',
                only: ['ADMIN'],
                isTab: true,
                children: [
                    {
                        // Deliverect日志
                        path: '/main/setting/deliverect-log',
                        name: 'deliverect_setting_page_text',
                        component: DeliverectPage,
                        id: '2_setting_deliverectPage',
                        pid: '2_setting',
                        only: ['ADMIN']
                    }, {
                        // Viva wallet 设置
                        path: '/main/setting/viva-wallet-setting',
                        name: 'viva_wallet_setting_page_text',
                        component: VivaWalletSettingPage,
                        id: '2_setting_vivaWalletSettingPage',
                        pid: '2_setting',
                        only: ['ADMIN']
                    }, {
                        // DataBubble 设置
                        path: '/main/setting/data-bubble',
                        name: 'data_bubble_setting_page_text',
                        component: DataBubblePage,
                        id: '2_setting_data_bubble',
                        pid: '2_setting',
                        only: ['ADMIN']
                    }, {
                        // Fiskaly 设置
                        path: '/main/setting/fiskaly',
                        name: 'fiskaly_setting_page_text',
                        component: FiskalySettingAdmin,
                        id: '2_setting_fiskaly',
                        pid: '2_setting',
                        only: ['ADMIN']
                    }, {
                        // Pixabay 搜图 Key 设置
                        path: '/main/setting/pixabay',
                        name: 'pixabay_setting_page_text',
                        component: PixabaySettingAdmin,
                        id: '2_setting_pixabay',
                        pid: '2_setting',
                        only: ['ADMIN']
                    }
                ]
            }, {
                // shark登录日志
                icon: () => <DisplaySettings />,
                path: '/main/shark',
                name: 'Shark',
                component: '',
                id: '2_shark',
                pid: '2',
                only: ['ADMIN', 'RESELLER'],
                isTab: true,
                children: [
                    {
                        // shark登录日志
                        path: '/main/shark/shark-login-operation',
                        name: 'shark_log_page_text_shark_login_log',
                        component: SharkLoginOperationList,
                        id: '2_shark_sharkLoginOperationList',
                        pid: '2_shark',
                    }, {
                        // shark版本分析
                        path: '/main/shark/shark-version-statistics',
                        name: 'shark_version_statistics_page_text',
                        component: SharkVersionList,
                        id: '2_shark_sharkVersionList',
                        pid: '2_shark',
                    }, {
                        // shark云端备份日志
                        path: '/main/shark/shark-backup-operation',
                        name: 'shark_cloud_backup_logs_page',
                        component: SharkBackupOperationList,
                        id: '2_shark_sharkBackupOperationList',
                        pid: '2_shark',
                    }, {
                        // Shark 密码解密
                        path: '/main/shark/shark-password-decryption',
                        name: 'shark_setting_page_text_shark_password_decryption',
                        component: SharkSetting,
                        id: '2_shark_sharkPasswordDecryption',
                        pid: '2_shark',
                        only: ['ADMIN']
                    }
                ]
            },
            {
                // 经销商
                icon: () => <AccountBoxOutlined />,
                path: '/main/reseller-list',
                name: 'reseller_page_text_reseller_list',
                component: ResellerManagement,
                id: '2_11',
                pid: '2',
                only: ['ADMIN'],
            },
            {
                // 余额明细
                icon: () => <MonetizationOnOutlined />,
                path: '/main/reseller-consumption-list',
                name: 'reseller_page_text_reseller_consumption_list',
                component: ResellerConsumptionPage,
                id: '2_12',
                pid: '2',
                only: ['ADMIN', 'RESELLER'],
            },
            {
                // 产品列表
                icon: () => <GridOn />,
                path: '/main/product-list',
                name: 'product_list_page_product_list',
                component: ProductListPage,
                id: '2_13',
                pid: '2',
                only: ['ADMIN'],
            },
            {
                // OCR列表（超管侧栏末项）
                icon: () => <DocumentScannerOutlined />,
                path: '/main/anagrafica-ocr-sessions',
                name: 'anagrafica_ocr_sessions_page_title',
                component: AnagraficaOcrSessionsPage,
                id: '2_14',
                pid: '2',
                only: ['ADMIN', 'RESELLER'],
            },
            {
                // 当前营业状态
                icon: () => <CurrentBusinessStatusIcon />,
                path: '/main/current-business-status',
                name: 'business_analysis_page_current_business_status',
                component: DataAnalysisManagement,
                id: '2_currentBusinessStatus',
                pid: '2',
                only: ['STAFF'],
            },
            {
                // 营业分析
                icon: () => <AnalysisIcon />,
                path: '/main/analysis',
                name: 'business_analysis_page_text_business_analysis',
                component: '',
                id: '2_6',
                pid: '2',
                only: ['STAFF'],
                isTab: true,
                children: [
                    {
                        // 餐厅营业数据分析
                        path: '/main/analysis/history-business',
                        name: 'business_analysis_page_text_operate_info',
                        component: HistoryDataPage,
                        id: '2_6_historyBusiness',
                        pid: '2_6',
                    },
                    {
                        // 历史订单数据
                        path: '/main/analysis/history-order',
                        name: 'history_order_data_page_text_historical_order_data',
                        component: HistoryOrderDataPage,
                        id: '2_6_historyOrder',
                        pid: '2_6',
                    },
                    {
                        // 餐厅菜品分析
                        path: '/main/analysis/dish-analysis',
                        name: 'business_analysis_page_msg_fetch_dish_analysis',
                        component: DishDataPage,
                        id: '2_6_dishAnalysis',
                        pid: '2_6',
                    },
                    {
                        // 日营业汇总
                        path: '/main/analysis/daily-summary',
                        name: 'daily_business_summary_page_text_daily_business_summary',
                        component: DailyBusinessSummaryPage,
                        id: '2_6_dailySummary',
                        pid: '2_6',
                    },
                    {
                        // 员工行为分析
                        path: '/main/analysis/staff-analysis',
                        name: 'business_analysis_page_msg_fetch_employee_analysis',
                        component: StaffDataPage,
                        id: '2_6_staffAnalysis',
                        pid: '2_6',
                    },
                    {
                        // 退菜详情分析
                        path: '/main/analysis/refund-detail',
                        name: 'business_analysis_page_refund_info',
                        component: (props: any) => <RefundDishDataPage {...props} pageType='CLOUD' />,
                        id: '2_6_refundDetail',
                        pid: '2_6',
                    },
                    {
                        // 敏感操作记录
                        path: '/main/analysis/sensitive-log',
                        name: 'business_analysis_page_sensitive_operation_record',
                        component: (props: any) => <SensitiveDataPage {...props} pageType='CLOUD' />,
                        id: '2_6_sensitiveLog',
                        pid: '2_6',
                    },
                ]
            },
            {
                // 集团营收分析（无负责集团时不展示侧栏入口，避免进入空页）
                icon: () => <GroupRevenueIcon />,
                path: '/main/group-revenue-analysis',
                name: 'group_revenue_analysis_page_text',
                component: GroupRevenueAnalysisPage,
                id: '2_groupRevenueAnalysis',
                pid: '2',
                only: ['STAFF'],
                requiredRestaurantWarrantCode: 'AU1030',
                visibleWhenHasResponsibleGroup: true,
            },
            {
                // 菜单库管理（与菜单商店、餐厅风控一致，需餐厅授权 AU1002）
                icon: () => <MenuLibraryIcon />,
                path: '/main/menu-library-management',
                name: 'menu_library_management_page_text',
                component: MenuLibraryManagementPage,
                id: '2_menuLibraryManagement',
                pid: '2',
                only: ['STAFF'],
                requiredRestaurantWarrantCode: 'AU1002',
            },
            {
                // 餐厅风控
                icon: () => <IntelligentRiskControlIcon />,
                path: '/main/intelligent-risk-control',
                name: 'intelligent_risk_control_page_text_restaurant_risk_control',
                component: IntelligentRiskControlPage,
                id: '2_intelligentRiskControl',
                pid: '2',
                only: ['STAFF'],
                requiredRestaurantWarrantCode: 'AU1002',
            },
            {
                // 云RBP
                icon: () => <CloudOutlined />,
                path: '/main/rbp-cloud',
                name: 'RBP Cloud',
                component: '',
                id: '2_8',
                pid: '2',
                isTab: true,
                only: ['STAFF'],
                children: [
                    {
                        // 我的餐厅（单页 + 顶部 Tab 切换子模块）
                        path: '/main/rbp-cloud/my-restaurant',
                        name: 'settings_page_text_my_restaurant',
                        component: MyRestaurantPage,
                        id: '2_8_1',
                        pid: '2_8',
                        /** 匹配 /info、/table-area 等子路径，由壳页内 Redirect 与 Tab 处理 */
                        exact: false,
                    },
                    {
                        // 菜单菜品（壳页统一隧道门禁；侧栏 children 仅用于导航）
                        path: '/main/rbp-cloud/dish-menu',
                        name: 'menu_and_dishes_page_label',
                        component: DishMenuShellPage,
                        id: '2_8_2',
                        pid: '2_8',
                        isTab: true,
                        isHideNav: true,
                        exact: false,
                        children: [
                            {
                                path: '/main/rbp-cloud/dish-menu/creator',
                                name: 'menu_dish_maker_page_text_menu_dish_marker',
                                component: '',
                                id: '2_8_2_1',
                                pid: '2_8_2',
                            },
                            {
                                path: '/main/rbp-cloud/dish-menu/extra-cost',
                                name: 'settings_page_text_extra_cost',
                                component: '',
                                id: '2_8_2_2',
                                pid: '2_8_2',
                            },
                            {
                                path: '/main/rbp-cloud/dish-menu/condiment',
                                name: 'settings_page_text_condiment',
                                component: '',
                                id: '2_8_2_3',
                                pid: '2_8_2',
                            },
                            {
                                path: '/main/rbp-cloud/dish-menu/sold-out',
                                name: 'dish_sold_out_page_label',
                                component: '',
                                id: '2_8_2_4',
                                pid: '2_8_2',
                            },
                            {
                                path: '/main/rbp-cloud/dish-menu/standard',
                                name: 'standard_set_page_label',
                                component: '',
                                id: '2_8_2_5',
                                pid: '2_8_2',
                            },
                            {
                                path: '/main/rbp-cloud/dish-menu/report-type',
                                name: 'dish_report_page_label',
                                component: '',
                                id: '2_8_2_6',
                                pid: '2_8_2',
                            },
                            {
                                path: '/main/rbp-cloud/dish-menu/job',
                                name: 'dish_job_type_page_label',
                                component: '',
                                id: '2_8_2_7',
                                pid: '2_8_2',
                            },
                            {
                                path: '/main/rbp-cloud/dish-menu/remarks',
                                name: 'quick_order_remarks_page_label',
                                component: '',
                                id: '2_8_2_8',
                                pid: '2_8_2',
                            },
                        ],
                    },
                    {
                        // 员工管理（单页 + 顶部 Tab：岗位设置、权限设置）
                        path: '/main/rbp-cloud/employee-management',
                        name: 'employee_management_page_label',
                        component: EmployeeManagementPage,
                        /** 与子功能管理 2_8_3 区分，避免路由树节点 id 重复 */
                        id: '2_8_5',
                        pid: '2_8',
                        exact: false,
                    },
                    {
                        // 子功能管理（云 RBP：顶部 Tab + 各子页）
                        path: '/main/rbp-cloud/sub-function',
                        name: 'settings_page_text_sub_function',
                        component: RbpCloudSubFunctionPage,
                        id: '2_8_3',
                        pid: '2_8',
                        exact: false,
                    },
                    {
                        // 娱乐项目管理（单页 + 顶部 Tab：预订时间、项目绑定、条款设置）
                        path: '/main/rbp-cloud/park-mode',
                        name: 'park_mode_page_text_title',
                        component: ParkModePage,
                        id: '2_8_4',
                        pid: '2_8',
                        exact: false,
                    },
                    {
                        // 打印（单页 + 顶部 Tab：基础设置、原生协议、设备、KWA/打印组、模板、队列、头尾）
                        path: '/main/rbp-cloud/print',
                        name: 'google_text_print',
                        component: PrintModulePage,
                        id: '2_8_6',
                        pid: '2_8',
                        exact: false,
                    },
                ]
            },

            {
                // 菜单商店
                icon: () => <MenuStoreIcon />,
                path: '/main/menu-store',
                name: 'menu_store_page_text',
                component: MenuStorePage,
                id: '2_menuStore',
                pid: '2',
                only: ['STAFF'],
                requiredRestaurantWarrantCode: 'AU1002',
            },

            {
                // 餐厅设置（与营业分析平级）
                icon: () => <DisplaySettings />,
                path: '/main/restaurant-settings',
                name: 'restaurant_settings_page_title',
                component: RestaurantSettingsPage,
                /** 仅双隧道餐厅展示营业分析数据来源设置入口 */
                visibleWhenHasDualAnalysisTunnel: true,
                id: '2_restaurantSettings',
                pid: '2',
                only: ['STAFF'],
            },
            {
                // Fiskaly 设置
                icon: () => <Settings />,
                path: '/main/fiskaly',
                name: 'fiskaly_setting_page_text',
                component: FiskalySettingStaff,
                visibleWhenSpain: true,
                id: '2_7',
                pid: '2',
                only: ['STAFF'],
            },

        ]
    },
    {
        path: '/staff',
        name: '登录',
        component: LoginPage,
        id: '1',
        pid: '0',
        purview: 'STAFF' as const,
        children: []
    },
    {
        path: '/admin',
        name: '登录',
        component: LoginPage,
        id: '3',
        pid: '0',
        purview: 'ADMIN' as const,
        children: []
    },
    {
        path: '/reseller',
        name: '登录',
        component: LoginPage,
        id: '4',
        pid: '0',
        purview: 'RESELLER' as const,
        children: []
    },
    {
        // Fiskaly 设置 游客
        path: '/upload-fiskaly',
        name: 'fiskaly_setting_page_text',
        component: FiskalySettingUser,
        id: '5',
        pid: '0',
    },
    // {
    //     // 帮助中心
    //     icon: () => <HelpCenterOutlined />,
    //     path: '/help-center',
    //     name: 'help_center_page_text_help_center',
    //     component: HelperCenter,
    //     id: '4',
    //     pid: '0',
    //     children: []
    // }
])

/**
 * 路由数据类型
 */
export type RoutesType = {
    /** 路由唯一标识 */
    id: string;
    /** 父级路由ID */
    pid: string;
    /** 路由路径 */
    path: string;
    /** 路由名称（国际化key） */
    name: string;
    /** 路由组件 - 支持任意 React 组件类型或空字符串（用于分组路由） */
    component: any;
    /** 子路由 */
    children?: RoutesType[];
    /** 是否为标签页 */
    isTab?: boolean;
    /** Main 内层 Switch 是否 exact；false 时匹配子路径（如「我的餐厅」壳页） */
    exact?: boolean;
    /** 是否隐藏导航 */
    isHideNav?: boolean;
    /** 路由图标 */
    icon?: () => JSX.Element;
    /** 权限类型（用于登录页） */
    purview?: 'ADMIN' | 'STAFF' | 'RESELLER';
    /** 允许访问的账户类型 */
    only?: Array<'STAFF' | 'ADMIN' | 'RESELLER'>;
    /** 是否为私有路由（需要登录） */
    private?: boolean;
    /** 为 true 时仅当当前餐厅国家为西班牙（country_code === '+34'）时在侧栏展示 */
    visibleWhenSpain?: boolean;
    /**
     * 为 true 时仅当账号存在至少一个负责集团（`userInfo.responsible_group` 非空）时在侧栏展示；
     * 用于集团营收等依赖集团上下文的入口。
     */
    visibleWhenHasResponsibleGroup?: boolean;
    /** 为 true 时仅当当前餐厅同时配置 ECCO/EFR 双隧道时在侧栏展示 */
    visibleWhenHasDualAnalysisTunnel?: boolean;
    /** 当前路由访问前必须通过的餐厅授权点 */
    requiredRestaurantWarrantCode?: WarrantCode;
}